import { takeLatest, call, put, cancelled, select } from 'redux-saga/effects'

// Helper for api errors
import { handleApiErrors, handleErrors } from '../../../lib/api-errors'
import axiosApi from '../../../views/client/axiosClient'
let clientApi = axiosApi()
import { storedb } from '../../../views/client/storedb'

// Our login constants
import {
  LOGIN_REQUESTING,
  LOGIN_SUCCESS,
  LOGIN_ERROR,
  LOGIN_URL,
} from './constants'

// So that we can modify our Client piece of state
import {
  setClient,
} from '../../client/actions'

import {
  setTokenAlive,
} from '../../../containers/Full/actions'


const getLoginState = state => state.login;

function handleRequest (request) {
  return request
    .then(handleApiErrors)
    .then( function(response){
      if (response && response.data) {
        return response.data
      } else {
        return response
      }
    })
    .then(json => json)
    .catch((error) => { 
      handleErrors(error); 
    });
}

function loginApi (postData) {
  const request = clientApi.post(LOGIN_URL, 
    postData
  );
  return handleRequest(request);
}

function* loginFlow () {
  const login = yield select(getLoginState);
  try {
    const dbContext = storedb();
    // try to call to our loginApi() function.  Redux Saga
    // will pause here until we either are successful or
    // receive an error
    const result = yield call(loginApi, login.postData)
    
    const code = result.code
    if (code != 200) {
      yield put({ type: LOGIN_ERROR, error: result.message })
    } else {
      const token = JSON.parse(result.token)
      const active2fa = token.active2fa || 0;
      let redirect = '';
      if (!active2fa){
        redirect = '/dashboard'
        // diable MFA login 
        // set token and redirect to dashboard
        yield put(setClient(token))
        // set token is alive 
        yield put(setTokenAlive(true))
        // set a stringified version of our token to localstorage on our domain
        dbContext.setToken(token);
      }
      else {
        redirect = '/loginmfa'
        localStorage.setItem('tmp', JSON.stringify(token))
      }

      yield put({ type: LOGIN_SUCCESS, data: result })
      login.history.push(redirect);
    }
  } catch (error) {
    // error? send it to redux
    yield put({ type: LOGIN_ERROR, error })
  } finally {
    // No matter what, if our `forked` `task` was cancelled
    // we will then just redirect them to login
    if (yield cancelled()) {
      login.history.push('/login');
    }
  }
}

// Our watcher (saga).  It will watch for many things.
function* loginWatcher () {
  yield takeLatest(LOGIN_REQUESTING, loginFlow)
}

export default loginWatcher



// WEBPACK FOOTER //
// ./src/views/Pages/Login/sagas.js